import { Controller } from "@hotwired/stimulus"

// Automatically marks a chatroom as read when new inbound messages arrive
// while the user is currently viewing that chatroom.
export default class extends Controller {
  static values = { chatroomId: Number }

  connect() {
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE && node.querySelector('.inbound')) {
            this.markAsRead()
            return
          }
        }
      }
    })

    this.observer.observe(this.element, { childList: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  markAsRead() {
    const chatroomId = this.chatroomIdValue
    if (!chatroomId) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (!csrfToken) return

    fetch(`/chatrooms/${chatroomId}/mark_read`, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json'
      }
    }).catch(() => {
      // Silently ignore errors - badge will update on next page load
    })
  }
}
